import {
  useChangePassword,
  useLogin,
  useMeQuery,
  useReqPasswordReset,
  useRequestMagicLink,
  useResetPassword,
  useSignUp,
  useUpdateMe,
  useVerifyEmail,
  useVerifyMagicLink,
} from './hooks';

// AuthService
export const AuthService = {
  login: useLogin,
  signUp: useSignUp,
  changePassword: useChangePassword,
  verifyEmail: useVerifyEmail,
  meQuery: useMeQuery,
  reqPasswordReset: useReqPasswordReset,
  requestMagicLink: useRequestMagicLink,
  verifyMagicLink: useVerifyMagicLink,
  resetPassword: useResetPassword,
  updateMe: useUpdateMe,
} as const;
